import useTranslation from "@babackapp/translations/use-translation";
import { TabsList, TabsTrigger } from "@babackapp/ui/components/tabs";

export default function ReturnReasonFormTabsList() {
  const t = useTranslation();

  return (
    <TabsList defaultValue="translations" className="w-full">
      <TabsTrigger className="flex-1" value="translations">
        {t("settings.reasons.tabs.translations")}
      </TabsTrigger>
      <TabsTrigger className="flex-1" value="options">
        {t("settings.reasons.tabs.options")}
      </TabsTrigger>
      <TabsTrigger className="flex-1" value="return-rules">
        {t("settings.reasons.tabs.returnRules")}
      </TabsTrigger>
    </TabsList>
  );
}
